import React, { Component } from 'react';

import './css/ClosedQuestion.css';
import ArrayUtils from "../../utils/ArrayUtils";
import StringUtils from "../../utils/StringUtils";

class ClosedQuestion extends Component {

    componentWillMount() {
        this.selectedCheckboxes = new Set();
        this.selectedRadio = '';

        const answers = this.props.answers;
        if (this.props.shuffle) {
            ArrayUtils.shuffle(answers);
        }
        const checked = new Array(answers.length).fill(false);

        const question = StringUtils.parse(this.props.question);

        this.setState({ checked: checked, answers: answers, question: question });
    }

    componentDidMount() {
        if (this.props.multipleChoice) {
            this.props.saveAnswer(this.props.id, Array.from(this.selectedCheckboxes));
        } else {
            this.props.saveAnswer(this.props.id, this.selectedRadio);
        }
    }

    handleChange = (label, number) => {
        if (this.props.multipleChoice) {
            this.toggleCheckbox(label);
            const checked = this.state.checked;
            checked[number] = !checked[number];

            this.setState({ checked: checked });
        } else {
            this.toggleRadio(label);

            const checked = new Array(this.props.answers.length).fill(false);;
            checked[number] = true;

            this.setState({ checked: checked });
        }
    }

    toggleCheckbox = label => {
        if (this.selectedCheckboxes.has(label)) {
            this.selectedCheckboxes.delete(label);
        } else {
            this.selectedCheckboxes.add(label);
        }
        this.props.saveAnswer(this.props.id, Array.from(this.selectedCheckboxes));
    }

    toggleRadio = label => {
        this.selectedRadio = label;
        this.props.saveAnswer(this.props.id, this.selectedRadio);
    }

    render() {
        let i = 1;
        const type = this.props.multipleChoice ? "checkbox" : "radio";
        const containerClass = type + "-container";
        const checked = this.state.checked;
        const answers = this.state.answers.map(answer => {
            const answerKey = "answer-" + this.props.questionNumber + "-" + i;
            const answerNumber = i - 1;
            i += 1;
            return (
                <label key={answerKey} className={"answer " + containerClass}>
                    <input type={type}
                           name={"answer-" + this.props.questionNumber}
                           id={answerKey}
                           checked={checked[answerNumber]}
                           value={answer}
                           onChange={() => this.handleChange(answer, answerNumber)}
                    />
                    <span className="checkmark" />
                    <label htmlFor={answerKey}>{StringUtils.parse(answer)}</label>
                </label>);
            }
        );
        return (
            <div className="task-block closed-question">
                <div className="question-number">Pytanie {this.props.questionNumber}</div>
                <div className="question">{this.state.question}</div>
                <fieldset id={"group-" + this.props.questionNumber}>
                    {answers}
                </fieldset>
            </div>
        );
    }
}

export default ClosedQuestion;